import { Component, ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { error: Error | null; }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{ background:'#0d0520', color:'white', padding:20, minHeight:'100vh' }}>
          <h2 style={{color:'#EF4444'}}>Error detectado</h2>
          <pre style={{fontSize:12, color:'#FCA5A5', whiteSpace:'pre-wrap'}}>
            {this.state.error.message}
            {'\n\n'}
            {this.state.error.stack?.split('\n').slice(0,5).join('\n')}
          </pre>
          <button onClick={() => this.setState({error:null})} style={{marginTop:20, padding:'10px 20px', background:'#534AB7', border:'none', color:'white', borderRadius:8}}>
            Volver al inicio
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
